import { MotionDiv } from '@/components/element/MotionDiv';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useMemo } from 'react';

export const ContractAlert = () => {
  const { _so_ } = useCurrentSalesOrder();

  const showAlert = useMemo(
    () => ['contracting', 'completed'].includes(_so_!.team_sales_order_phase.name) && !_so_!.closed,
    [_so_]
  );

  if (showAlert) {
    return (
      <MotionDiv className="alert alert-warning text-white">
        <span className="alert-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </span>
        <span className="alert-text text-sm">
          このプロジェクトは承認された契約タスクが存在しません。
        </span>
      </MotionDiv>
    );
  } else {
    return null;
  }
};
